import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ModalContext } from './modal.directive';

export type ModalKey = {};

export type Modals = Map<ModalKey, TemplateRef<ModalContext>>;

@Injectable({ providedIn: 'root' })
export class ModalService {
  private readonly modals: Modals = new Map();

  change = new BehaviorSubject<Modals>(this.modals);

  addModal(modal: TemplateRef<ModalContext>): {} {
    const key = {};
    this.modals.set(key, modal);
    this.change.next(new Map(this.modals));
    return key;
  }

  removeModal(key: {}) {
    this.modals.delete(key);
    this.change.next(new Map(this.modals));
  }
}
